import { useParams } from 'react-router-dom';
import { useSchoolDetailsQuery, useMySchoolQuery, UserPermissions } from '../../../generated/graphql';
import { MY_DISTRICT, MY_SCHOOL } from '../../../variables/constant';
import usePermission from '../../../hooks/usePermission';
import useRole from '../../../hooks/useRole';

interface RouteProp {
  id: string
}

const useSchool = () => {
  const { id } = useParams<RouteProp>();
  const { isSchoolAdmin, isDistrictAdmin, isSuperAdmin } = useRole();
  const { data, loading } = useSchoolDetailsQuery({
    fetchPolicy: 'network-only',
    variables: {
      id,
    },
    skip: id === MY_SCHOOL,
  });

  const { data: mySchoolData, loading: mySchoolLoading } = useMySchoolQuery({
    fetchPolicy: 'network-only',
    skip: id !== MY_SCHOOL && (id !== MY_DISTRICT && !isSchoolAdmin),
  });

  const { hasPermission: editSchoolPermission } = usePermission(UserPermissions.EditSchools);


  return {
    loading: loading || mySchoolLoading,
    school: data?.schoolDetails || mySchoolData?.mySchool,
    editSchoolPermission,
    isSchoolAdmin,
    isDistrictAdmin, schoolID: id,
    isSuperAdmin,
  };
};

export default useSchool;
